<template>
    <div class="available-internships-overview">
        <div class="component-title">
            <h4 class="title">{{ $t('internship.choose_internship') }}</h4>
            <b-button
                class="btn-add btn-add-own-internship"
                variant="primary"
                @click="createInternship">
                {{ $t('internship.add_own_internship') }}
            </b-button>
        </div>

        <div class="internships-grid">
            <design-2021-internships-filters-component
                :internship-in="internshipsIn"
                :filters-in="filters"
                @filter-updated="updateFilter">
            </design-2021-internships-filters-component>

            <div class="internships">
                <design-2021-internships-student-tools-component
                    @update-search-term="updateSearchTerm"
                    @update-sorting="updateModuleSorting">
                </design-2021-internships-student-tools-component>

                <div class="internships-wrapper">
                    <design-2021-internships-student-internship-card-component
                        v-for="internship of pagedFilteredInternships"
                        :internship-in="internship"
                        :class="false"
                        :signed="false"
                        @show-modal-detail="showInternshipDetail"
                        :key="internship.id">
                        <template #header>
                            <div class="available-placements">
                                <b-badge
                                    v-if="hasAvailableplacements(internship)"
                                    variant="primary">
                                    <i class="fas fa-users icon"></i>
                                    {{ `${internship.placements_filled} / ${internship.placements}` }}
                                </b-badge>

                                <b-badge
                                    v-else
                                    variant="danger">
                                    Vol
                                </b-badge>
                            </div>
                        </template>
                    </design-2021-internships-student-internship-card-component>
                </div>

                <div
                    class="apprentice-pagination"
                    v-if="filteredInternships.length > perPage">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage">
                    </b-pagination>
                </div>
            </div>
        </div>

        <design-2021-internship-student-motivation-modal-component
            ref="student-motivation-modal"
            :project-in="projectIn"
            :google-map-api="googleMapApi"
            @signed-internship="signUp">
        </design-2021-internship-student-motivation-modal-component>

        <design-2021-internships-student-personal-create-modal-component
            ref="create-personal-internship"
            :project-in="projectIn"
            @signed-internship="signUp">
        </design-2021-internships-student-personal-create-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internships-student-signup-index-component',
    props: ['internshipsIn', 'projectIn', 'googleMapApi'],
    data() {
        return {
            filters: {
                tags: [],
                locations: [],
                organization: [],
                type: [],
            },

            searchTerm: '',
            perPage: 9,
            currentPage: 1,
        };
    },
    methods: {
        signUp(project) {
            this.$emit('update-signed-internship', project);
        },

        showInternshipDetail(internship) {
            this.$refs['student-motivation-modal'].show(internship, this.projectIn.id, false);
        },

        updateFilter(filters) {
            this.filters = { ...filters };
        },

        createInternship() {
            this.$bvModal.show('create-personal-internship');
        },

        updateSearchTerm(term) {
            this.searchTerm = term;
        },

        updateModuleSorting(value) {
            this.sorting = value;
        },

        hasAvailableplacements(internship) {
            return internship.placements > internship.placements_filled;
        },

        getOwnerTypeClass(model) {
            switch (model) {
                case 'App\\Models\\User':
                    return 'fad fa-user-crown';

                case 'App\\Models\\Organization\\Organization':
                case 'App\\Models\\School':
                    return 'fad fa-university';
            }
        },

        getOwnerTypeText(model) {
            switch (model) {
                case 'App\\Models\\User':
                    return this.$t('internship.personal_internship');

                case 'App\\Models\\Organization\\Organization':
                    return this.$t('internship.external_internship');

                case 'App\\Models\\School':
                    return this.$t('internship.school_internship');
            }
        },
    },

    computed: {
        filteredInternships() {
            if (!this.internshipsIn.length) {
                return [];
            }

            let internships = this.internshipsIn.filter((internship) => {
                if (this.filters.tags.length > 0) {
                    let checked = false;

                    internshipTagsLoop: for (const internshipTag of this.filters.tags) {
                        for (const tags of internship.internship_tags) {
                            if (tags.id === internshipTag) {
                                checked = true;
                                break internshipTagsLoop;
                            }
                        }
                    }

                    if (!checked) {
                        return false;
                    }
                }

                if (this.filters.locations.length > 0) {
                    let checked = false;

                    internshipLocationLoop: for (const internshipLocation of this.filters.locations) {
                        if (internship.location.toLowerCase() === internshipLocation.toLowerCase()) {
                            checked = true;
                        }
                    }

                    if (!checked) {
                        return false;
                    }
                }

                if (this.searchTerm.length >= 3) {
                    let check = false;
                    const lowerCasedTerm = this.searchTerm.toLowerCase();

                    if (internship.name.toLowerCase().includes(lowerCasedTerm)) {
                        check = true;
                    }

                    if (internship.description.toLowerCase().includes(lowerCasedTerm)) {
                        check = true;
                    }

                    if (internship.organization.toLowerCase().includes(lowerCasedTerm)) {
                        check = true;
                    }

                    for (const tag of internship.internship_tags) {
                        if (tag.name.toLowerCase().includes(lowerCasedTerm)) {
                            check = true;
                            break;
                        }
                    }

                    if (!check) {
                        return false;
                    }
                }

                return true;
            });

            return internships;
        },

        pagedFilteredInternships() {
            if (this.filteredInternships.length > this.perPage) {
                const start = (this.currentPage - 1) * this.perPage;
                return this.filteredInternships.length - start > this.currentPage
                    ? this.filteredInternships.slice(start, this.perPage * this.currentPage)
                    : this.filteredInternships.slice(start);
            }

            return this.filteredInternships;
        },

        rows() {
            return this.internshipsIn ? this.internshipsIn.length : 0;
        },
    },
};
</script>

<style scoped lang="scss">
.component-title {
    flex-direction: column;
    justify-content: flex-start;
    row-gap: map-get($grid-gutter-spacing, 'fifteen');

    .title {
        text-align: left;
        align-self: flex-start;
    }

    .btn-add-own-internship {
        margin-right: 0;
        width: 100%;
    }
}

.available-placements {
    .badge {
        font-size: 0.75rem;
        padding: 4px 8px;

        .icon {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .component-title {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        row-gap: 0;

        .title {
            align-self: center;
        }

        .btn-add-own-internship {
            margin-right: 0;
            width: auto;
        }
    }

    .internships-grid {
        display: grid;
        grid-template-columns: 250px 1fr;
        gap: $grid-gutter-width;
    }

    .internships-filters {
        grid-column: 1;
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .internships-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: stretch;
        column-gap: $grid-gutter-width;

        .internship-card {
            flex: 0 1 calc(50% - 15px);
            height: initial;
        }
    }
}

@media (min-width: 1600px) {
    .internships-wrapper {
        .internship-card {
            flex: 0 1 calc(33.3333% - 20px);
        }
    }
}
</style>
